function Article2 () {
    return <p>En cours de réalisation...</p>
}
export default Article2